import styled from "@emotion/styled";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import { ReactComponent as InfoIcon } from "Components/_Shared/Icons/Assets/info.svg";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import type { FC, PropsWithChildren } from "react";

const StyledHint = styled(Box)`
  ${({ theme }) => `
    box-sizing: border-box;
    background-color: ${theme.colors.brandLight};
    padding: ${theme.spacing(Spacing.L)};
    border-radius: ${theme.spacing(Radius.L)};
    width: 100%;
    margin-top: ${theme.spacing(Spacing.XL)};
  `}
`;

export const ExpensesHint: FC<PropsWithChildren> = ({ children }) => {
  const theme = useTheme();
  return (
    <StyledHint>
      <Grid container justifyContent="space-between">
        <Grid size={0.7}>
          <InfoIcon color={theme.palette.primary.main} />
        </Grid>

        <Grid size={11.3}>
          <Box>
            <Typography variant="body2" lineHeight={1.3}>
              {children}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </StyledHint>
  );
};
